import { createSelector } from '@ngrx/store';
import { AppState, getAppState } from '../registration';
import { CoreState } from '../reducers';

export const getCoreState = createSelector(getAppState, (state: AppState) => {
    return state.core;
});

export const getDriver = createSelector(getCoreState, (state: CoreState) => state.driver);
export const getDriverName = createSelector(getCoreState, (state: CoreState) => state.driverName);
export const getOfflineStatus = createSelector(getCoreState, (state: CoreState) => state.offline);
export const getReturningToOnline = createSelector(getCoreState, (state: CoreState) => state.onlineReturning);
export const getAppInitComplete = createSelector(getCoreState, (state: CoreState) => state.initComplete);
export const getCurrLang = createSelector(getCoreState, (state: CoreState) => state.currLang);

export const getUiDriverName = createSelector(getDriver, getDriverName, (driver, driverName) => {
    if (!driver) {
        return null;
    }
    // TODO
    const requiresName = driver.sharedAccount;
    if (!requiresName || (requiresName && !driverName)) {
        return driver.name;
    } else {
        return `${driverName?.firstName} ${driverName?.lastName}`;
    }
});

export const getAccountName = createSelector(getDriver, driver => {
    return driver?.name;
});

export const getUiAccName = createSelector(getDriver, driver => {
    return driver?.sharedAccount ? driver?.name : null;
});

export const getDriverMeta = createSelector( getDriver, driver => {
   return driver ? { opco: driver.opco, locale: driver.locale } : { opco: null, locale: 'en'};
});
